import { useQuery } from '@tanstack/react-query';
import type { Campaign } from '@seo/types';
import { apiGet } from '@/lib/api';

const TERMINAL = new Set(['completed', 'failed', 'cancelled']);

export function useCampaign(id: string) {
  return useQuery({
    queryKey: ['campaign', id],
    queryFn: () => apiGet<Campaign>(`/v1/campaigns/${id}`),
    enabled: Boolean(id),
    refetchInterval: (q) => {
      const data = q.state.data as Campaign | undefined;
      if (!data) return 4000;
      return TERMINAL.has(data.status) ? false : 4000;
    },
  });
}
